<p
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  [ngClass]="frame?.rtlEnabled ? 'works_HeadLine_vague_rtl' : 'works_HeadLine_vague'"
  [ngClass.xs]="'works_HeadLineXS_vague'"
>
  <mark class="works_HeadLineMark">{{ workNavigationContext?.work?.headerTypeDisplayText }}</mark>
  {{ workNavigationContext?.work?.objectDesignation }}
  @if (workNavigationContext?.work?.street) {
    <mark class="works_HeadLineMark">
      {{ res.get('Works-Task-Detail-Street') }}
    </mark>
  }
  {{ workNavigationContext?.work?.street }}
</p>
<div [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'" class="detailPage_Navigation_Buttons" fxLayout="row">
  <work-navigation [disabled]="this.worksService.isResourceListVisible"></work-navigation>
  <div class="task_HeadLine">
    <mark class="works_HeadLineMark workTextPadding">{{ res.get('Works-Task-Detail-Work') }}</mark>
    <span>{{ workNavigationContext?.work?.designation }}</span>

    <div fxLayout="row" fxLayout="row wrap" fxLayoutGap="10px" style="align-items: center">
      <abc-button
        stylingMode="text"
        style="margin-left: 10px"
        class="navigationActionButton"
        [icon]="res.svgUrl('Save-Image')"
        [visible]="!frame.mapInfo.isReadOnly"
        [disabled]="!allowPersistence"
        (onClick)="save()"
      >
        >
      </abc-button>

      <abc-button
        stylingMode="text"
        class="navigationActionButton"
        [icon]="res.svgUrl('Cancel-Image')"
        [visible]="!frame.mapInfo.isReadOnly"
        [disabled]="!allowPersistence"
        (onClick)="revert()"
      >
      </abc-button>

      @if (allowDeletion) {
        <abc-button
          stylingMode="text"
          class="toolBarButton navigationActionButton"
          [icon]="res.svgUrl('Delete-Image')"
          [visible]="!frame.mapInfo.isReadOnly"
          (onClick)="delete()"
        >
        </abc-button>
      }

      <abc-button
        stylingMode="text"
        class="navigationActionButton"
        [icon]="res.svgUrl('CompleteAll-Image')"
        [visible]="!frame.mapInfo.isReadOnly && showCompleteAll"
        [disabled]="!allowCompleteAll"
        (onClick)="completeAll()"
      >
      </abc-button>

      @if (showResourceToggleButton) {
        <abc-button
          stylingMode="text"
          class="navigationToggleButton"
          [icon]="res.svgUrl('Resources-Image')"
          [type]="worksService.isResourceListVisible ? 'default' : 'normal'"
          [disabled]="
            workNavigationContext?.work?.workTypeDurationModeValue === WorkTypeDurationMode.Erforderlich &&
            !workNavigationContext.work.duration
          "
          (onClick)="worksService.toggleResourceListView()"
        >
        </abc-button>
      }

      @if (frame.mapInfo.isReadOnly) {
        <div class="works_isReadOnly">
          {{ res.get('Works-Task-Detail-ReadOnlyMessage') }}
        </div>
      }
    </div>
  </div>
</div>
<div
  id="scrollArea"
  class="scollDiv"
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  id="scrollArea"
  style="overflow-y: auto"
>
  @if (!this.worksService.isResourceListVisible) {
    @if (workNavigationContext.work?.workTypeDurationModeValue !== WorkTypeDurationMode.NichtRelevant) {
      <dx-validation-group style="display: contents" #valiGroupDuration>
        <abc-number-box
          [labelMode]="'floating'"
          [label]="res.get('Works-Detail-Duration')"
          [showClearButton]="true"
          [stylingMode]="'underlined'"
          [(value)]="workNavigationContext.work.duration"
          class="workDetailDuration"
          [format]="WorkConstants.DurationFormatString"
          valueChangeEvent="keyup"
        >
          <dx-validator>
            @if (
              workNavigationContext.work?.workTypeDurationModeValue === WorkTypeDurationMode.Erforderlich &&
              (workNavigationContext.work?.anyTaskFinished || workNavigationContext.work?.anyResultSelected)
            ) {
              <dxi-validator-validation-rule type="required"></dxi-validator-validation-rule>
            }
          </dx-validator>
        </abc-number-box>
      </dx-validation-group>
      <br />
      <mark class="works_tasks_header">{{ res.get('Works-Detail-WorkSteps') }}</mark>
    }
    <mat-vertical-stepper
      #stepper
      class="workDetailStepper"
      [selectedIndex]="selectedTaskIndex"
      animationDuration="0ms"
    >
      <ng-template matStepperIcon="done" let-index="index">
        <mat-icon [svgIcon]="res.svgName('Done-Image')"></mat-icon>
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="default" let-index="index">
        {{ index + 1 }}
      </ng-template>
      @for (task of workNavigationContext?.work?.tasks; track trackById(i, task); let i = $index) {
        @if (task.isVisible) {
          <mat-step [label]="task.designation" [state]="task.finished ? 'done' : 'default'" [completed]="task.finished">
            <table class="taskDetail_Table">
              <tr>
                <td style="padding-left: 10px">
                  <abc-check-box
                    class="workStepDoneCheckBox"
                    [(value)]="task.finished"
                    [disabled]="task.preventFinishing || frame.mapInfo.isReadOnly"
                    [text]="res.get('Works-Detail-WorkStepDone')"
                  >
                  </abc-check-box>
                </td>
              </tr>
              <tr style="height: 20px">
                @if (task.resultsRequired) {
                  <td class="task_resultsRequired" style="padding-top: 10px">
                    {{ res.get('Works-Detail-ResultsRequired') }}
                  </td>
                }
              </tr>
              <tr>
                <td>
                  <abc-text-area
                    [(ngModel)]="task.description"
                    [autoResizeEnabled]="true"
                    [disabled]="this.frame.mapInfo.isReadOnly"
                    [labelMode]="'floating'"
                    [placeholder]="res.get('Works-Task-Detail-Description')"
                    [stylingMode]="'underlined'"
                    [validationStatus]="'valid'"
                    class="task_description_formField"
                  >
                  </abc-text-area>
                </td>
              </tr>
              <tr style="height: 10px"></tr>
              <tr>
                <td>
                  <abc-button
                    class="captureResultFont"
                    [stylingMode]="'contained'"
                    [text]="res.get('Works-Detail-CaptureResult')"
                    [disabled]="CompareHelper.isEmptyObject(task?.resultCategories)"
                    (onClick)="navigateToTaskDetailWithAutoOpen(i)"
                  >
                  </abc-button>
                </td>
              </tr>
            </table>
          </mat-step>
        }
      }
    </mat-vertical-stepper>
  }
  <div [ngStyle]="{ display: this.worksService.isResourceListVisible ? 'initial' : 'none' }">
    <router-outlet></router-outlet>
  </div>
</div>
